import React, { ReactElement, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { isEmpty, isDateDifferenceLessThan15Days } from '../../utils/helpers';
import { LANGUAGE_SESSION_STORAGE_KEY } from '../../utils/constants/sessionStorageConstants';
import { getClientTermsAndConditions } from '../../store/termsAndConditionsSlice';
import { TermsAndConditionsInterface } from '../../interfaces/TermsAndConditionsInterface';

const TermsAndConditions = ({
  productType,
  selectedClient,
  termsAndConditionsText,
  accountOpenDate,
  asOfDateValue,
}: TermsAndConditionsInterface): ReactElement => {
  const tncResponse: any = useSelector(getClientTermsAndConditions);

  const [tncUrl, setTncUrl] = useState<string>('');
  const selectedLanguage = sessionStorage.getItem(LANGUAGE_SESSION_STORAGE_KEY);

  const findTnc = (clientId: string) => {
    let url = '';

    const selectedClientTnc =
      tncResponse && clientId && tncResponse[clientId]
        ? tncResponse[clientId]
        : {};

    // do not set url if date diff is more than equal to 15 days
    const isDateDifferenceValid = isDateDifferenceLessThan15Days(
      accountOpenDate,
      asOfDateValue,
    );

    if (!isEmpty(selectedClientTnc) && isDateDifferenceValid) {
      const {
        genericTermsAndConditions,
        dcTermsAndConditions,
        plccTermsAndConditions,
      } = selectedClientTnc;

      if (productType === 'DUAL_CARD' && dcTermsAndConditions) {
        url = dcTermsAndConditions;
      } else if (productType === 'PLCC_CARD' && plccTermsAndConditions) {
        url = plccTermsAndConditions;
      } else {
        url = genericTermsAndConditions;
      }
    }
    setTncUrl(url);
  };

  useMemo(() => findTnc(selectedClient), [selectedClient, selectedLanguage]);

  return tncUrl ? (
    <div className="terms-and-conditions-button">
      <a href={tncUrl} target="_blank">
        {termsAndConditionsText}
      </a>
    </div>
  ) : (
    <></>
  );
};

export default TermsAndConditions;
